import { useMemo } from "react"

import createStore from "@Stores/base-factories"
import { hookRewardList } from "@Stores/base-factories/store-list"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useRewardFactory = ({ fetch, siteSelected: { id: siteId }, collection: { setItem } }) => useMemo(() => ({
  upload: async file => {
    const formData = new FormData()
    formData.append('file', file)

    const data = await fetch({
      method: 'post',
      url: "rewards/upload",
      data: formData,
      params: { siteId },
    });

    if (!data) {
      throw Error()
    }

    return data
  },
  deleteStep: async id => {
    const data = await fetch({
      method: 'delete',
      url: `reward-step/${id}`,
      params: { siteId },
    })

    return data
  },
  updateStepActive: async (id, active, points) => {
    const data = await fetch({
      method: 'put',
      url: `reward-step/${id}`,
      data: { active, points, siteId },
    })

    return data
  },
  reloadReward: async id => {
    const data = await fetch({
      method: 'get',
      url: `reward/${id}`,
      params: { siteId },
    })

    setItem(data)
  },
  duplicateReward: async row => await fetch({
    method: 'post',
    url: `reward/duplicate`,
    data: { ...row, siteId },
  }),
}), [fetch, siteId, setItem])

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('reward')
  .extendHookCollectionsFactory('rewards')
  .extend(useRewardFactory)
  .extend(hookRewardList('rewards'))
  .factory()

export {
  Provider as RewardProvider,
  useStore as useRewardStore,
}
